import { render, staticRenderFns } from "./notification-bell.component.vue?vue&type=template&id=2089fc4a&"
import script from "./notification-bell.component.ts?vue&type=script&lang=ts&"
export * from "./notification-bell.component.ts?vue&type=script&lang=ts&"
import style0 from "./notification-bell.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports